import { render, staticRenderFns } from "./DropdownUserMenu.vue?vue&type=template&id=582e1502&scoped=true&"
import script from "./DropdownUserMenu.vue?vue&type=script&lang=js&"
export * from "./DropdownUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./DropdownUserMenu.vue?vue&type=style&index=0&id=582e1502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582e1502",
  null
  
)

export default component.exports